import { createContext } from 'react';

interface AuthContextProps {
    buckets: number[];
}

const defaultState: AuthContextProps = {
    buckets: [],
};

export const authContext = createContext(defaultState);

export const AuthProvider = authContext.Provider;
export const AuthConsumer = authContext.Consumer;
